(() => {
  const initialize = (scope) => scope.querySelectorAll('[data-simple-pdp]').forEach((section) => {
    if (section.dataset.simpleReady) return;
    section.dataset.simpleReady = 'true';
    section.querySelector('[data-souk-review-proof]')?.setAttribute('allow-hash-change', '');
    const sticky = section.querySelector('[data-otp-sticky-atc]');
    const main = section.querySelector('[data-otp-main-product-form] button[type="submit"]');
    const footer = section.querySelector('.oui-footer');
    const drawer = document.querySelector('cart-drawer');
    if (!sticky || !main) return;
    let frame;
    const update = () => {
      if (!matchMedia('(max-width: 699px)').matches) return;
      const rect = main.getBoundingClientRect();
      const mainVisible = rect.top < innerHeight && rect.bottom > 96;
      const visible = !mainVisible && footer.getBoundingClientRect().top > innerHeight + 96 && !drawer?.hasAttribute('open');
      sticky.classList.toggle('is-visible', visible);
      if (sticky.getAttribute('aria-hidden') !== String(!visible)) sticky.setAttribute('aria-hidden', String(!visible));
      if (sticky.hasAttribute('inert') === visible) sticky.toggleAttribute('inert', !visible);
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    new MutationObserver(schedule).observe(sticky, {attributes:true,attributeFilter:['class','aria-hidden','inert']});
    if (drawer) new MutationObserver(schedule).observe(drawer, {attributes:true,attributeFilter:['open']});
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule);
    update();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
